(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotspot"] && !Shopify.designMode) return;
  try {
    
  class HotspotSection {
    constructor(container) {
      this.container = container;
      this.buttons = container.querySelectorAll('[data-hotspot-trigger]');
      this.cards = container.querySelectorAll('[data-hotspot-card]');
      this.closeBtns = container.querySelectorAll('[data-hotspot-close]');
      this.init();
    }

    init() {
      this.buttons.forEach(btn => btn.addEventListener('click', (e) => this.toggleCard(e)));
      this.closeBtns.forEach(btn => btn.addEventListener('click', (e) => { e.stopPropagation(); this.closeAll(); }));
      document.addEventListener('click', (e) => { if (!this.container.contains(e.target)) this.closeAll(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.closeAll(); });
      
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => this.closeAll(), 250);
      });
    }

    toggleCard(e) {
      if (e.target.closest('.hotspot-card')) return;
      e.preventDefault(); e.stopPropagation();

      const btn = e.currentTarget;
      const wrapper = btn.closest('.hotspot-item');
      const card = wrapper.querySelector('[data-hotspot-card]');
      if (!card) return;

      const isOpening = card.hidden || card.getAttribute('aria-hidden') === 'true';
      this.closeAll();

      if (isOpening) {
        card.hidden = false;
        this.smartPosition(card, wrapper);
        requestAnimationFrame(() => {
          card.setAttribute('aria-hidden', 'false');
          btn.setAttribute('aria-expanded', 'true');
        });
      }
    }

    smartPosition(card) {
        const currentClasses = Array.from(card.classList);
        const directionClass = currentClasses.find(c => c.startsWith('hotspot-card--'));
        let currentDir = directionClass ? directionClass.replace('hotspot-card--', '') : 'top-right';

        card.style.transform = '';
        const cardRect = card.getBoundingClientRect();
        const viewportW = window.innerWidth;
        const viewportH = window.innerHeight;
        let newDir = currentDir;
        
        if (cardRect.right > viewportW) newDir = newDir.replace('right', 'left');
        else if (cardRect.left < 0) newDir = newDir.replace('left', 'right');

        const headerHeight = 80; 
        if (cardRect.bottom > viewportH) newDir = newDir.replace('bottom', 'top');
        else if (cardRect.top < headerHeight) newDir = newDir.replace('top', 'bottom');

        if (newDir !== currentDir) {
            card.classList.remove(`hotspot-card--${currentDir}`);
            card.classList.add(`hotspot-card--${newDir}`);
        }
        
        // Final nudge
        const finalRect = card.getBoundingClientRect();
        const margin = 15;
        let nudgeX = 0;
        if (finalRect.right > (viewportW - margin)) nudgeX = (viewportW - margin) - finalRect.right;
        else if (finalRect.left < margin) nudgeX = margin - finalRect.left;

        if (nudgeX !== 0) card.style.transform = `translateX(${nudgeX}px)`;
    }

    closeAll() {
      this.cards.forEach(card => {
        card.setAttribute('aria-hidden', 'true');
        setTimeout(() => {
          if (card.getAttribute('aria-hidden') === 'true') {
             card.hidden = true;
             card.style.transform = ''; 
          }
        }, 250);
      });
      this.buttons.forEach(btn => btn.setAttribute('aria-expanded', 'false'));
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.hotspot-wrapper').forEach(el => new HotspotSection(el));
  });
  
  document.addEventListener('shopify:section:load', (e) => {
    const wrapper = e.target.querySelector('.hotspot-wrapper');
    if(wrapper) new HotspotSection(wrapper);
  });

  } catch(e) { console.error(e); }
})();
})();
